export default "<div id=\"viewerContainer\" tabindex=\"0\">\n    <div id=\"viewer\" class=\"pdfViewer\"></div>\n</div>";